<section class="wrapper" [class.compact]="compact">
  <span class="plan-name">{{plan.name}}</span>

  <div class="price-part">
    <span class="plan-price" [class.enterprise]="plan.isEnterprise">{{getPriceLabel() | translate}}</span>
    <span class="user-per-month"
          *ngIf="!isYearlyPlan() && !plan.isEnterprise"
          translate>
      PLANS.BRIEF.USER_PER_MONTH
    </span>
    <span class="user-per-month"
          *ngIf="plan.isEnterprise"
          [class.enterprise]="plan.isEnterprise"
          translate>
      PLANS.BRIEF.MORE_USERS
    </span>
  </div>
    <div class="web-call-limit">
      <span class="web-call-limit-number"
          translate>{{ getWebCallValue() }}
      </span>
      <span class="web-call-limit-text" translate>PLANS.BRIEF.WEB_CALLS</span>
    </div>

  <button mat-raised-button
          color="info-full"
          [disabled]="!canSubscribe"
          (click)="subscribe()"
  >
    {{buttonKey | translate}}
  </button>

</section>
